<template>
    <ToolButton :Editor="Editor" KnownIcon="H4" @ToolClick="Editor.chain().focus().toggleHeading({level:4}).run()" 
        :class="{ 'toggled': Editor.isActive('heading', { level: 4 }) }">

    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>